import React, { FC, ReactElement } from 'react';
import classNames from 'classnames';

import ContentArea from 'components/common/ContentArea';

import { OverlayWrapperComponentProps } from './interfaces';

import useStyles from './style';

const OverlayWrapper: FC<OverlayWrapperComponentProps> = ({
  overlayWrapperClassName,
  overlay,
  ...rest
}) => {
  const classes = useStyles();

  return !!overlay ? (
    <ContentArea
      shadowed
      {...rest}
      className={classNames('overlayWrapper', classes.viboOverlayWrapper, overlayWrapperClassName)}
    >
      {overlay as ReactElement}
    </ContentArea>
  ) : null;
};

export default OverlayWrapper;
